import React from "react";
import { NProgress } from "@tanem/react-nprogress";

function ProgressBar({ isAnimating }) {
  return (
    <NProgress isAnimating={isAnimating}>
      {({ isFinished, progress, animationDuration }) => (
        <div
          style={{
            opacity: isFinished ? 0 : 1,
            pointerEvents: "none",
            transition: `opacity ${animationDuration}ms linear`,
          }}
        >
          <div
            style={{
              background: "#00ab55",
              height: "3px",
              left: 0,
              margin: 0,
              position: "fixed",
              top: 0,
              transition: `margin-left ${animationDuration}ms linear`,
              width: "100%",
              transform: `translateX(${(-1 + progress) * 100}%)`,
              zIndex: 2000,
            }}
          />
        </div>
      )}
    </NProgress>
  );
}

export default ProgressBar;
